/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const setEvaluationRequestSchema = z.object({
  governanceTier: z.enum(['LIGHTWEIGHT', 'STANDARD', 'HIGH_CONTROL']).nullish(),
  score: z.number().nullish(),
});
